import type { useIntl } from "react-intl";
import { z } from "zod";

export const createLoginSchema = (intl: ReturnType<typeof useIntl>) =>
	z.object({
		email: z.email({
			message: intl.formatMessage({
				id: "form.field.email.invalid",
				defaultMessage: "Invalid email address",
			}),
		}),
		password: z.string().min(6, {
			message: intl.formatMessage({
				id: "form.field.password.min",
				defaultMessage: "At least 6 characters",
			}),
		}),
	});
